import { render, staticRenderFns } from "./PresentationVideo.vue?vue&type=template&id=2fbe0b7e"
import script from "./PresentationVideo.vue?vue&type=script&lang=js"
export * from "./PresentationVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports